import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { JwBootstrapSwitchNg2Module } from 'jw-bootstrap-switch-ng2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DxVectorMapModule, DxPieChartModule } from 'devextreme-angular';
// * Shared Components 
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';
//* Importaciones para Translate Module
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { LoadTranslateJSON } from '../utils/supplies.utils';

@NgModule({
  declarations: [
    NavbarComponent, 
    SidebarComponent, 
    FooterComponent
  ],
  imports: [
    CommonModule, 
    HttpClientModule,
    RouterModule, 
    FormsModule,
    JwBootstrapSwitchNg2Module,
    NgbModule,
    DxVectorMapModule,
    DxPieChartModule,
    TranslateModule.forChild({
      loader:{
        provide: TranslateLoader,
        useFactory: (LoadTranslateJSON),
        deps: [HttpClient]
      }
    }),
  ], 
  exports: [
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    TranslateModule
  ]
})
export class SharedModule { }
